<template>
  <div class="retake--wrap">
    <content-box v-if="state === 'beforeRequest'"
                  class="state__before"
                  :width="'430px'"
                  :height="'290px'">
      <ui-loading-circle>
        <span v-html="$t('lnb.claimIssue.retake.bLoginTrue.ing.desc')"></span>
      </ui-loading-circle>
    </content-box>
    <content-box v-else-if="state === 'ing'"
                 class="state__ing"
                 :width="'600px'">
      <i class="icon icon--camera-size70"></i>
      <p class="title" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.title')"></p>
      <div class="loading--wrap">
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
      </div>
      <p class="desc" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.desc')"></p>
      <div class="tip--wrap">
        <i class="text-tip">Tip !</i>
        <div class="swiper-container" ref="swiperWrap">
          <div class="swiper-wrapper"
               :class="{isDragging}"
               :style="{left: slidePosition}"
               ref="slides"
               @mousedown="onHandleStart"
               @touchstart="onHandleStart"
          >
            <div class="list1 swiper-slide" :class="{ active: currentIndex === 0 }">
              <div class="content--wrap">
                <div class="question">
                  <i class="icon icon--user"></i>
                  <div class="text--wrap">
                    <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list1.question')"></p>
                  </div>
                </div>
                <div class="answer">
                  <div class="text--wrap">
                    <p>
                      <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list1.answer')"></span>
                    </p>
                    <figure class="img__capture" :class="$i18n.locale"></figure>
                    <span>
                      <span class="first-text" v-html="$t('common.uxAnalysisImage')"></span>
                      <span class="second-text" v-html="$t('common.heatmapImage')"></span>
                      <span class="third-text" v-html="$t('common.captureImage')"></span>
                    </span>
                  </div>
                  <i class="icon icon--logo-mini"></i>
                </div>
              </div>
            </div>
            <div class="list2 swiper-slide" :class="{ active: currentIndex === 1 }">
              <div class="content--wrap">
                <div class="question">
                  <i class="icon icon--user"></i>
                  <div class="text--wrap">
                    <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.question')"></p>
                  </div>
                </div>
                <div class="answer">
                  <div class="text--wrap">
                    <p>
                      <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.answer')"></span>
                      <span class="ex-text" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list2.ex')"></span>
                    </p>
                    <figure class="img__css" :class="$i18n.locale"></figure>
                  </div>
                  <i class="icon icon--logo-mini"></i>
                </div>
              </div>
            </div>
            <div class="list3 swiper-slide" :class="{ active: currentIndex === 2 }">
              <div class="content--wrap">
                <div class="question">
                  <i class="icon icon--user"></i>
                  <div class="text--wrap">
                    <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list3.question')"></p>
                  </div>
                </div>
                <div class="answer">
                  <div class="text--wrap">
                    <p>
                      <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list3.answer')"></span>
                    </p>
                    <figure class="img__bLogin" :class="$i18n.locale"></figure>
                  </div>
                  <i class="icon icon--logo-mini"></i>
                </div>
              </div>
            </div>
            <div class="list4 swiper-slide" :class="{ active: currentIndex === 3 }">
              <div class="content--wrap">
                <div class="question">
                  <i class="icon icon--user"></i>
                  <div class="text--wrap">
                    <p v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list4.question')"></p>
                  </div>
                </div>
                <div class="answer">
                  <div class="text--wrap">
                    <p>
                      <span class="first" v-html="$t('lnb.claimIssue.retake.bLoginFalse.ing.slide.list4.answer')"></span>
                    </p>
                    <figure class="img__bMobile" :class="$i18n.locale"></figure>
                  </div>
                  <i class="icon icon--logo-mini"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination" ref="pagination">
            <template v-for="index in slides.length">
              <span
                :key="index"
                class="dot"
                :class="{ active: index - 1 === currentIndex }"
                @click="goToSlide(index - 1)"
              ></span>
            </template>
          </div>
          <div v-show="!isFirstSlide"
               ref="swiperLeft"
               class="swiper-button-prev icon icon--prev-gray-size20"
               @click="prevSlide"
          ></div>
          <div v-show="!isLastSlide"
               ref="swiperRight"
               class="swiper-button-next icon icon--prev-gray-size20"
               @click="nextSlide"
          ></div>
        </div>
      </div>
    </content-box>
    <content-box v-else-if="state === 'failed'"
                  class="state__fail"
                  :width="'430px'">
      <i class="icon icon--camera-error-size50"></i>
      <p class="title">{{ $t('lnb.claimIssue.retake.bLoginFalse.fail.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.retake.bLoginFalse.fail.desc') }}</p>
      <ui-button
        @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </content-box>
    <content-box v-else-if="state === 'error'"
                 class="state__fail"
                 :width="'430px'">
      <i class="icon icon--camera-error-size50"></i>
      <p class="title">{{ $t('lnb.claimIssue.retake.bLoginFalse.error.title') }}</p>
      <p class="desc">{{ $t('lnb.claimIssue.retake.bLoginFalse.error.desc') }}</p>
      <ui-button
        @click="onCloseLayer">{{ $t('common.confirm') }}</ui-button>
    </content-box>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiButton from '@/components/ui/UiButton'
import { requestCapture, getCaptureStatus } from '@/api/capture'
import { CAPTURE_SUCCESS } from '@/libs/apply-helper'

export default {
  components: {
    ContentBox,
    UiLoadingCircle,
    UiButton
  },
  props: [
    'aid'
  ],
  data () {
    return {
      state: 'beforeRequest', // beforeRequest, ing, success, failed, error
      swiperLayoutWidth: 560,
      slides: [],
      currentIndex: 0,
      slideInterval: null,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  created () {
    this.aidList = []
    this.aidList.push({
      aid: this.aid,
      state: '',
      timer: null,
      bAB: false
    })

    if (this.$route.params.abAid) {
      this.aidList.push({
        aid: this.$route.params.abAid,
        state: '',
        timer: null,
        bAB: true
      })
    }

    this.aidList.forEach((aid, index) => {
      this.captureRequest(aid, index)
    })
  },
  mounted () {
    this.startAutoSlide()
  },
  beforeDestroy () {
    this.stopAutoSlide()
  },
  computed: {
    isFirstSlide () {
      return this.currentIndex === 0
    },
    isLastSlide () {
      if (this.slides) {
        return this.currentIndex === this.slides.length - 1
      }
      return false
    }
  },

  methods: {
    captureRequest (aid, index) {
      requestCapture(aid.aid, aid.bAB).then(data => {
        return data
      }).then(data => {
        const requestId = data.requestId
        const uuid = data.uuid

        if (index === this.aidList.length - 1) {
          this.state = 'ing'
        }

        this.$nextTick().then(() => {
          if (index === 0) {
            this.initSwiper()
          }
        })

        this.aidList[index].timer = setInterval(() => {
          getCaptureStatus(requestId, uuid, true).then(tasks => {
            if (!tasks.length) {
              throw new Error('no tasks')
            }

            let successCount = 0
            let failedCount = 0

            for (const item of tasks) {
              if (item.statusCode === CAPTURE_SUCCESS) {
                successCount++
              } else if (item.statusCode < 0) {
                failedCount++
              }

              if (successCount + failedCount === tasks.length) {
                clearInterval(this.aidList[index].timer)

                if (successCount === 0) {
                  this.aidList[index].state = 'failed'

                  let failedCheck = true
                  this.aidList.forEach(item => {
                    if (item.state !== 'failed') {
                      failedCheck = false
                    }
                  })

                  if (failedCheck) {
                    this.state = 'failed'
                  }
                } else {
                  this.aidList[index].state = 'success'

                  let successCheck = true
                  this.aidList.forEach(item => {
                    if (item.state !== 'success') {
                      successCheck = false
                    }
                  })

                  if (successCheck) {
                    this.state = 'success'
                    this.$emit('onCaptureSuccess', tasks)
                  }
                }
              }
            }
          }).catch(err => {
            throw err
          })
        }, 5000)
      }).catch(err => {
        clearInterval(this.timer)
        this.state = 'error'
        console.error(err)
      })
    },
    onCloseLayer () {
      this.$emit('closeLayer')
    },
    initSwiper () {
      this.slides = document.querySelectorAll('.swiper-slide')

      this.getTransformStyle()
    },
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
      this.stopAutoSlide()
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 558) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.dragOffset > 50) {
        this.prevSlide()
      } else if (this.dragOffset < -50) {
        this.nextSlide()
      } else {
        this.resetDrag()
      }
      this.isDragging = false
      this.startX = 0
      this.endX = 0
      this.getTransformStyle()
      this.startAutoSlide()
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 558) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    },
    startAutoSlide () {
      this.slideInterval = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopAutoSlide () {
      if (this.slideInterval) {
        clearInterval(this.slideInterval)
        this.slideInterval = null
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.retake--wrap {
  .title {
    font-size: 20px;
    font-weight: 600;
    color: #444444;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  & > [class*=state__] {
    text-align: center;
    position: relative;
    box-sizing: border-box;
  }

  .state__before {
    /deep/ .loading.position {
      top: 100px;
      transform: translate(-50%, 0);
      .desc {
        white-space: nowrap;
        font-size: 14px;
        color: #2f2f2f;
      }
    }
  }

  .state__ing {
    padding: 20px;
    .icon--camera-size70 {
      margin-top: 30px;
    }
    .title {
      color: $brandColor;
      margin-top: 11px;
    }
    .desc {
      line-height: 1.5;
      color: #444444;
      margin-top: 27px;

      span {
        color: $brandColor;
      }
    }
    .loading--wrap {
      width: 180px;
      height: 12px;
      margin: 18px auto 0;

      .loading-bar {
        display: block;
        position: absolute;
        padding: 6px;
        border-radius: 50%;
        background-color: $brandColor;
        animation: loading 1.4s ease-in-out 0s infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }
        &:nth-child(2) {
          animation-delay: 0.15s;
        }
        &:nth-child(3) {
          animation-delay: 0.3s;
        }
        &:nth-child(4) {
          animation-delay: 0.45s;
        }
        &:nth-child(5) {
          animation-delay: 0.6s;
        }
      }
    }
    .tip--wrap {
      position: relative;
      margin: 20px auto 0;
      box-sizing: border-box;
      width: 560px;
      height: 385px;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      background-color: #ebebeb;
      overflow: hidden;

      .swiper-container {
        width: 100%;
        height: 100%;
        overflow: hidden;

        margin: 0 auto;
        position: relative;
        list-style: none;
        padding: 0;
        z-index: 1;

        /deep/ .swiper-wrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 1;
          display: flex;
          box-sizing: content-box;
          transition: left 0.3s ease;

          &.isDragging {
            transition: initial;
          }
        }
        .swiper-slide {
          position: relative;
          flex-shrink: 0;
          width: 100%;
          height: 100%;
          transition-property: transform;
          margin-top: 0;

          display: flex;
          justify-content: center;
          align-items: center;

          padding-left: 40px;
          padding-right: 40px;
          box-sizing: border-box;

          & > div {
            @include positionYcenter;
            width: 100%;
            padding: 0 40px;
            box-sizing: border-box;
            background-color: transparent;
            box-shadow: none;
          }
        }
      }

      /deep/ .swiper-pagination {
        display: flex;
        position: absolute;
        bottom: 3%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;

        .dot {
          width: 8px;
          height: 8px;
          background-color: rgba(0, 0, 0, 0.15);
          border-radius: 100%;
          margin: 0 5px;
          cursor: pointer;
          display: flex;
          transition: all .3s;

          &.active {
            background: #FFF;
          }

          &:hover {
            background-color: #aaa;
          }
        }
      }
      .swiper-button-next, .swiper-button-prev {
        @include positionYcenter;
        z-index: 10;
        cursor: pointer;
        padding: 10px;
        background-position: center;
      }
      .swiper-button-prev {
        left: 0px;
        right: auto;
      }
      .swiper-button-next {
        right: 0px;
        left: auto;
        transform: rotate(180deg) translateY(50%);
      }

      i.text-tip {
        display: inline-block;
        width: 37px;
        height: 20px;
        line-height: 22px;
        border-radius: 4px;
        background-color: #43b6c9;

        font-size: 12px;
        font-weight: 600;
        color: #ffffff;

        position: absolute;
        top: 8px;
        left: 8px;
      }

      .text--wrap {
        display: inline-block;
        font-size: 13px;
        font-weight: 600;
        box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
        border-radius: 16px;
      }

      .question {
        text-align: left;

        .icon {
          width: 32px;
          height: 32px;
          background-color: #fff;
          background-position: center;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          vertical-align: top;
          margin: 0;
          margin-right: 8px;
        }
        .text--wrap {
          color: #2f2f2f;
          background-color: #ffffff;
          border-top-left-radius: 0;
          min-height: 35px;
          line-height: 35px;
          padding-left: 15px;
          padding-right: 17px;
          padding-top: 7.5px;
          padding-bottom: 8px;
          box-sizing: border-box;

          p {
            line-height: 1.5;
          }
        }
      }

      /deep/ .answer {
        text-align: right;
        margin-top: 20px;

        .icon {
          width: 32px;
          height: 32px;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          background-color: #ffffff;
          background-position: center;
          vertical-align: top;
          margin-left: 8px;
        }
        .text--wrap {
          background-color: #2f2f2f;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.54;
          color: #ffffff;
          border-top-right-radius: 0;
          padding-top: 20px;
          padding-left: 22px;
          padding-bottom: 30px;
          padding-right: 22px;
          position: relative;
          width: 380px;
          box-sizing: border-box;
          white-space: normal;
          text-align: left;

          p {
            text-align: left;
            display: inline-block;
            span {
              display: inline-block;
              &:not(.first) {
                margin-top: 20px;
              }
            }
            strong {
              color: #ffd100;
            }
            .ex-text {
              color: #d7d7d7;
            }
          }

          figure {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            &.img__capture {
              width: 304px;
              height: 80px;
              margin: 20px auto 12px;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-7_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-7_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-7_en.png');
              }

              & + span {
                display: block;
                margin: 0 auto;
                width: 304px;
                font-size: 12px;
                font-weight: 600;
                color: #d7d7d7;
                white-space: nowrap;

                span {
                  display: inline-block;
                  width: 83px;
                  text-align: center;
                  &.first-text {
                    margin-right: 28px;
                  }
                  &.second-text {
                    margin-right: 28px;
                  }
                  &.third-text {
                    color: #ffd100;
                  }
                }
              }
            }
            &.img__css {
              width: 274px;
              height: 80px;
              margin-top: 20px;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_3-3_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_3-3_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_3-3_en.png');
              }
            }
            &.img__bLogin {
              width: 256px;
              height: 97px;
              margin: 28px auto 0;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-8_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-8_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-8_en.png');
              }
            }
            &.img__bMobile {
              width: 320px;
              height: 121px;
              margin: 15px auto 0;

              &.ko {
                background-image: url('../../assets/img/page/regi_guide_2-9_ko.png');
              }
              &.ja {
                background-image: url('../../assets/img/page/regi_guide_2-9_ja.png');
              }
              &.en {
                background-image: url('../../assets/img/page/regi_guide_2-9_en.png');
              }
            }
          }
        }
      }
    }
  }

  .state__fail {
    padding-top: 50px;
    padding-bottom: 25px;
    .title {
      margin-top: 15px;
    }
    .desc {
      margin-top: 12px;
    }
    .ui-btn {
      margin-top: 60px;
    }
  }
}
@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}

@-webkit-keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
